import React from 'react';
import { TriggerContext, TriggerContextProps } from '../context/TriggerContext';
import { Trigger } from '../types/trigger';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const triggerState = {
  items: new Map<string, Trigger>(),
  loading: false,
};

export const triggerSlice = createSlice({
  name: 'trigger',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      triggerState.items = new Map();
      triggerState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<Trigger[]>) => {
      triggerState.items = new Map();
      action.payload.forEach(p => triggerState.items.set(p.id, new Trigger(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<Trigger[]>) => {
      action.payload.forEach(p => triggerState.items.set(p.id, new Trigger(p)));
      triggerState.items = new Map(triggerState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<Trigger[]>) => {
      action.payload.forEach(p => triggerState.items.delete(p.id));
      triggerState.items = new Map(triggerState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      triggerState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface TriggerProviderProps {
  children: React.ReactNode;
}

export default function TriggerProvider({ children }: TriggerProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.triggers.key);

  const triggerContext: TriggerContextProps = {
    triggers: triggerState.items,
    triggersLoading: triggerState.loading,
    setTriggers: (triggers: Map<string, Trigger>) => {
      dispatch(triggerSlice.actions.set([...triggers.values()]));
    },
  };

  return <TriggerContext.Provider value={triggerContext}>{children}</TriggerContext.Provider>;
}
